import React, { createContext, useEffect, useState } from "react";
//import all_product from "../Components/Assets/all_product";

export const shopContext = createContext(null)

const getDefaultCart = () => {
  let cart = {}
  for (let index = 0; index < 300 + 1; index++) {
    cart[index] = 0;

  }
  return cart
}

const ShopContextProvider = (props) => {
  const [all_product, setAll_product] = useState([])

  const [CartItems, SetCartItems] = useState(getDefaultCart())

  useEffect(() => {

    fetch('http://localhost:4000/allproducts')
      .then((res) => res.json())
      .then((data) => {
        setAll_product(data)

      })

      if (localStorage.getItem('auth-token')) {
        fetch('http://localhost:4000/getcartdata', {
         method: 'POST',
         headers: {
           Accept: 'application/form-data',
           'auth-token':`${localStorage.getItem('auth-token')}`,
           'Content-Type': 'application/json'
         },
         body: ''
       })
         .then((res) => res.json())
         .then((data) => {
          SetCartItems(data)
  
         })
  
     }


  }, [])

  const addToCart = (itemId) => {
    SetCartItems((prev) => ({
      ...prev,
      [itemId]: prev[itemId] + 1
    }))

    if (localStorage.getItem('auth-token')) {
       fetch('http://localhost:4000/addtocart', {
        method: 'POST',
        headers: {
          Accept: 'application/form-data',
          'auth-token':`${localStorage.getItem('auth-token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"itemId":itemId})
      })
        .then((res) => res.json())
        .then((data) => {
         //console.log(data,"dataitemid")

        })

    }

    //console.log(typeof (CartItems[itemId]), "cartItemsssss")
  }

  const removeFromCart = (itemId) => {
    SetCartItems((prev) => ({
      ...prev,
      [itemId]: prev[itemId] - 1
    }))

    //remove
    if (localStorage.getItem('auth-token')) {
      fetch('http://localhost:4000/removefromcart', {
       method: 'POST',
       headers: {
         Accept: 'application/form-data',
         'auth-token':`${localStorage.getItem('auth-token')}`,
         'Content-Type': 'application/json'
       },
       body: JSON.stringify({"itemId":itemId})
     })
       .then((res) => res.json())
       .then((data) => {
        //console.log(data,"dataitemid")

       })

   }

  }

  const getTotalCartAmount = () => {
    let totalAmount = 0
    for (const item in CartItems) {
      if (CartItems[item] > 0) {
        let itemInfo = all_product.find((product) => product.id === Number(item))
        totalAmount += itemInfo.new_price * CartItems[item]
      }

    }

    return totalAmount



  }

  const getTotalCartItems = () => {
    let totalItem = 0
    for (const item in CartItems) {
      if (CartItems[item] > 0) {
        totalItem += CartItems[item]
      }

    }

    return totalItem



  }
  const contextVlue = { getTotalCartItems, getTotalCartAmount, all_product, CartItems, addToCart, removeFromCart }

  return (
    <shopContext.Provider value={contextVlue}>
      {props.children}
    </shopContext.Provider>
  )
}


export default ShopContextProvider;

